<template>
    <div class="card is-min-width-700">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-40px">
            <h1 class="title is-size-3">
              {{ $t('echeancierFacturation.popUpEcheancierManuel.title') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content is-paddingless mgr-40px mgl-40px mgt-40px">
        <error-msg-component :messages="messages"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :error="error"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"/>
        <div class="columns is-multiline">
          <div class="column is-4">
            <b-field :label="$t('echeancierFacturation.popUpEcheancierManuel.debut')"
            class="obligatoire">
              <b-datepicker show-week-number
                            icon="calendar-today"
                            :editable="true"
                            v-model="echeanciers[0].dateDebut"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('echeancierFacturation.popUpEcheancierManuel.fin')"
                     class="obligatoire">
              <b-datepicker show-week-number
                            icon="calendar-today"
                            :editable="true"
                            v-model="echeanciers[0].dateFin"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field
            :label="$t('echeancierFacturation.popUpEcheancierManuel.datePremiereEcheance')">
              <b-datepicker show-week-number
                            icon="calendar-today"
                            :editable="true"
                            v-model="echeanciers[0].dateFinPremiereEcheance"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-12 columns  is-marginless pdb-0 pdl-0">
            <div class="column is-offset-1 is-5 obligatoire pdl-0">
              <b-field :label="$t('echeancierFacturation.popUpEcheancierManuel.periodicite')"
                       class="obligatoire">
              </b-field>
            </div>
          </div>
          <div class="column is-12 columns pdt-0">
            <div class="column is-1 pdr-0 mgv-auto has-tex-default">
              {{ $t('echeancierFacturation.popUpEcheancierManuel.tousLes') }}
            </div>
            <div class="column is-2 pdl-0">
              <b-input v-model="echeanciers[0].quantitePeriodicite"
                       type="number">
              </b-input>
            </div>
            <div class="column is-3 pdl-0">
              <b-select v-model="echeanciers[0].unitePeriodicite" expanded>
                <option v-for="(periodicite, index) in LISTE_UNITE_ECHEANCIER_FACTURATION"
                        :value="periodicite.code"
                        :key="index.code">
                  {{ $t(periodicite.libelle) }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
        <b-field class="mgt-20px pdb-40px">
          <div class="is-pulled-left boutonAction">
            <a class="button is-cancel btn-modal-annuler" @click="$parent.close">
              {{ $t('echeancierFacturation.popUpEcheancierManuel.actions.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="generationEcheancierManuel()">
              {{ $t('echeancierFacturation.popUpEcheancierManuel.actions.generer') }}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { LISTE_UNITE_ECHEANCIER_FACTURATION } from '@/configuration/devisConf';
import { echeancierGeneration as echeancierGenerationInCmd } from '@/api/commande';
import { echeancierGeneration as echeancierGenerationInDevis } from '@/api/devis';
import messageErreur from '@/services/general/messageErreur';
import formatDate from '@/services/general/formatIsoDate';
import validationEcheancier from '@/services/commande/echeancierFacturation/validationEcheancier';
import validation from '@/services/validation/validation';
import translate from '@/services/commande/echeancierFacturation/translator';
import messageSucces from '@/services/general/messageSucces';
import genererGuid from '@/services/general/genererGuid';
import calculArrondi from '@/services/calcul/calculArrondi';

export default {
  props: {
    echeanciers: {
      type: Array,
      required: true,
    },
    payeurs: {
      type: Array,
      required: true,
    },
    isDevis: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      LISTE_UNITE_ECHEANCIER_FACTURATION: LISTE_UNITE_ECHEANCIER_FACTURATION,
      montantFromPopUp: 0,
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    async genEcheancierUnitaire(tmpEcheancier, loadingComponent, paramEcheancier) {
      const echeancierToSend = cloneDeep(paramEcheancier);
      if (!echeancierToSend.unitePeriodicite
            || echeancierToSend.quantitePeriodicite < 1) {
        this.messages.push({
          message: 'echeancierFacturation.messages.errors.required.quantitePeriodicite',
        });
        this.error = true;
        loadingComponent.close();
        return;
      }
      echeancierToSend.dateDebut = formatDate(echeancierToSend.dateDebut);
      echeancierToSend.dateFin = formatDate(echeancierToSend.dateFin);
      echeancierToSend.dateFinPremiereEcheance = formatDate(
        echeancierToSend.dateFinPremiereEcheance,
      );
      let echeancier = null;
      let montant = tmpEcheancier.echeancierLignes.reduce((a, b) => {
        return a + b.montant;
      }, 0);
      montant = calculArrondi(montant);
      if (tmpEcheancier.montant) montant = tmpEcheancier.montant;
      if (this.isDevis) {
        echeancier = (await echeancierGenerationInDevis(
          echeancierToSend, montant, this.payeurs,
        )).data.result;
      } else {
        echeancier = (await echeancierGenerationInCmd(
          echeancierToSend, montant, this.payeurs,
        )).data.result;
      }
      echeancier.echeancierLignes.forEach((ligne) => {
        ligne.id = genererGuid();
        ligne.fromGeneration = true;
        ligne.dateDebut = new Date(ligne.dateDebut);
        ligne.dateFin = new Date(ligne.dateFin);
        ligne.datePrevisionnelleFacturation = new Date(ligne.datePrevisionnelleFacturation);
      });
      tmpEcheancier.id = echeancier.id;
      tmpEcheancier.echeancierLignes = echeancier.echeancierLignes;
      if (tmpEcheancier.dateFin == null) tmpEcheancier.dateFin = echeancier.dateFin;
    },
    async generationEcheancierManuel() {
      const loadingComponent = this.$buefy.loading.open();
      const promesse = [];
      this.error = false;
      this.messages = [];
      this.messagesChampsVide = [];
      this.champsVide = [];
      try {
        for (let i = 0; i < this.echeanciers.length; i += 1) {
          const tmpEcheancier = this.echeanciers[i];
          promesse.push(this.genEcheancierUnitaire(tmpEcheancier, loadingComponent,
            this.echeanciers[0]));
        }
        await Promise.all(promesse);
        if (this.error) throw new Error();
        loadingComponent.close();
        messageSucces(this.$i18n.t('echeancierFacturation.messages.success.generation'));
        this.$emit('updateEcheancierMasse', this.echeanciers);
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error.validationErrors) {
          validationEcheancier(e.response, this.messages);
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
};
</script>
